import Form from '../components/Form';


export default function ContactPage() {
    return (
        <Form />
    );
}